/** Level 2 (claude/level-2-source): 28 lessons + 4a Ten Symbols and 6a Trading Tens (not in the book yet) + the
 *  standards lessons of Oct 30, 2026 (level2/standards.ts: 6b, 7a, 12a, 13a, 14a, 16a, 21a, 22a, 22b, 25a, 27a);
 *  Beginning Check-Up = the Level 1 Check-Up; then the Level 2 Check-Up. */
import type { Lesson } from "../types";
import * as A from "./lesson01to10";
import * as B from "./lesson11to20";
import * as C from "./lesson21to28";
import { L2_LESSON4A, L2_LESSON6A } from "./extra";
import * as X from "./standards";

export const LEVEL2: Lesson[] = [
  A.L2_LESSON1, A.L2_LESSON2, A.L2_LESSON3, A.L2_LESSON4, L2_LESSON4A, A.L2_LESSON5, A.L2_LESSON6, L2_LESSON6A, X.L2_LESSON6B, A.L2_LESSON7, X.L2_LESSON7A, A.L2_LESSON8, A.L2_LESSON9, A.L2_LESSON10,
  B.L2_LESSON11, B.L2_LESSON12, X.L2_LESSON12A, B.L2_LESSON13, X.L2_LESSON13A, B.L2_LESSON14, X.L2_LESSON14A, B.L2_LESSON15, B.L2_LESSON16, X.L2_LESSON16A, B.L2_LESSON17, B.L2_LESSON18, B.L2_LESSON19, B.L2_LESSON20,
  C.L2_LESSON21, X.L2_LESSON21A, C.L2_LESSON22, X.L2_LESSON22A, X.L2_LESSON22B, C.L2_LESSON23, C.L2_LESSON24, C.L2_LESSON25, X.L2_LESSON25A, C.L2_LESSON26, C.L2_LESSON27, X.L2_LESSON27A, C.L2_LESSON28,
];
export { L2_POST } from "./checkups";
